import { motion } from "framer-motion";
import logo from "../../assets/images/YouTube-white.svg";
import StyledLogo from "../Utils/Logo.styled";
import { LoaderContainer, StyledLoader, LoaderLogo } from "./Loader.styled";

const transition = {
  hidden: { opacity: 0, scale: 0 },
  show: {
    opacity: 1,
    scale: 4,
    translateX: "50%",
    translateY: "-50%",
    transition: {
      duration: 1.6,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 1,
    },
  },
};

const exit = {
  exit: {
    opacity: 1,
    translateY: "100vh",
    transition: {
      duration: 2,
    },
  },
};

const Loader = ({ setLoading }) => {
  return (
    <LoaderContainer
      key="loader"
      as={motion.div}
      onAnimationComplete={() => setLoading(false)}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <StyledLoader as={motion.div} variants={exit} />
      <LoaderLogo as={motion.div} variants={transition}>
        <StyledLogo key="logo-1" layoutId="logo-1" src={logo} />
      </LoaderLogo>
    </LoaderContainer>
  );
};

export default Loader;
